import { Box, Slide, LoginPrompt, TripTrackingTabs } from 'src/components';
import { useState } from 'react';
import { TripsList, Statistics, VisualisationsMenu } from '../../index';
import { useAuth } from 'src/utils';
import { useIsMobile } from 'src/hooks';

export default function TripsOverview({ 
  isPublicPortal, 
  trips, 
  steps,
  handleTripSelect, 
  setDrawerState, 
  setSelectedTripSteps, 
  totalTripKms, 
  totalTripTime,
  setTripsOverviewTab,
  toggleVisualisationView,
  mapRef }) {

  const [tab, setTab] = useState(isPublicPortal ? 1 : 0); //Start public portal on stats
  const [slideDirection, setSlideDirection] = useState("left");

  const { user } = useAuth();
  const isMobile = useIsMobile();

  const handleTabChange = (event, newValue) => {
    if (newValue > tab) {
      setSlideDirection("left"); // Going forward
    } else {
      setSlideDirection("right"); // Going backward
    }

    setTab(newValue);
    setTripsOverviewTab?.(newValue);

    if (newValue === 1 && isMobile) { //Stats
      setDrawerState("half");
    }
  };

  return (
    <Box sx={{ m: 2, mt: isMobile ? 0 : 2, flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      
      <TripTrackingTabs 
        tab={tab}
        handleTabChange={handleTabChange}
        label="Trips" />

      {!user && !isPublicPortal && (
        <LoginPrompt 
          message={"Log in to start tracking your trips."}
          height={isMobile ? '150px' : "70%"} />
      )}

      <Slide direction={slideDirection} in={tab === 0} mountOnEnter unmountOnExit timeout={500}>
          <Box sx={{ flex: 1, display: tab === 0 ? 'flex' : 'none', flexDirection: 'column', overflow: 'hidden' }}>
              <TripsList 
                isPublicPortal={isPublicPortal}
                trips={trips} 
                handleViewChange={handleTripSelect} 
                setDrawerState={setDrawerState} />
          </Box>
      </Slide>

      <Slide direction={slideDirection} in={tab === 1} mountOnEnter unmountOnExit timeout={500}>
          <Box sx={{ pt: 1, flex: 1, display: tab === 1 ? 'flex' : 'none', flexDirection: 'column', overflow: 'hidden' }}>
              <Statistics 
                isPublicPortal={isPublicPortal}
                steps={isPublicPortal ? steps : null}
                trips={trips} 
                type="global" 
                title="All Trips Summary" 
                setSelectedTripSteps={setSelectedTripSteps} 
                totalTripKms={totalTripKms}
                totalTripTime={totalTripTime} />
          </Box>
      </Slide>

      <Slide direction={slideDirection} in={tab === 2} mountOnEnter unmountOnExit timeout={500}>
          <Box sx={{ pt: 1, flex: 1, display: tab === 2 ? 'flex' : 'none', flexDirection: 'column', overflow: 'hidden' }}>
              <VisualisationsMenu 
                setDrawerState={setDrawerState} 
                isTripDetailsTab={false}
                toggleVisualisationView={toggleVisualisationView}
                mapRef={mapRef} />
          </Box>
      </Slide>

    </Box>
  );
}
